import React from "react";
import { BRAND } from "../lib/site";

export default function LegalPage({ title, kicker, children, testid }) {
  return (
    <div data-testid={testid} className="bg-mag">
      <section className="pt-16 pb-10 border-b border-[rgba(212,175,55,0.2)]">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-body">{kicker}</span>
          <h1 className="font-heading text-5xl md:text-6xl text-white mt-3">{title}</h1>
          <p className="text-white/55 text-sm mt-4">
            Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
          </p>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <article className="max-w-4xl mx-auto px-6 md:px-10 prose prose-invert">
          <div className="text-white/80 font-heading text-lg leading-relaxed space-y-6">
            {children}
            <p className="text-white/55 text-sm mt-12">
              Questions about this policy? Contact {BRAND.name} at{" "}
              <a href={`mailto:${BRAND.email}`} className="text-gold">{BRAND.email}</a> or{" "}
              <a href={`tel:+1${BRAND.phoneHref}`} className="text-gold">{BRAND.phone}</a>.
            </p>
          </div>
        </article>
      </section>
    </div>
  );
}
